// extracted by mini-css-extract-plugin
module.exports = {"parallax-background":"ParallaxBackground_parallax-background__2Idbm"};